// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"411":"671cfc41","505":"a6532c31","761":"5ed9a9af","796":"216ddd9d","988":"1ba915b0"}[chunkId] + ".css";
};